<template>
	<card class="ReChannelEdit">
		<h3 class="mb-1" v-if="bIsNew">Новый канал</h3>
		<!--Новый канал заменить на{{strChannelName}} или что там будет в будущем объекте-->
		<h3 v-else>Редактирование канала</h3>
		<hr />

		<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiSaveMethod"
			:SuccessGo="SuccessGo" 
			:CancelGo="CancelGo"/>
	</card>
</template>

<script>
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: "ReChannelEdit",
	components: {
		ReFormPrinter
	},
	props: {
		counter: String,
		findId: {
			type: String,
			default: ""
		},
		objChannel: Object
	},
	data() {
		return {
			masAllFormParams: this.currentFormConfig(),
			currentApiSaveMethod: this.currentApiSaveChannelMethod(),
		};
	},
	computed: {
		bIsNew: function() {
			if (location.pathname.indexOf("/data/line/channel/add") !== -1) {
				return true;
			}
			return false;
		}
		/*strChannelName: function() {
			if (typeof this.objChannel.id != "undefined") {
				return this.objChannel.title;
			}
			return "Новый канал";
		}*/
	},

	methods: {
		currentFormConfig() {
			const channel_id = typeof this.$route.params.channel_id == 'undefined'?'':this.$route.params.channel_id;
			//return require("src/conf/channelsFormConfig.js").channels_config;
			this.$GVO.ApiCall('GET_CHANNEL_FORM',{obj:'SOC',flt:{id:channel_id}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiSaveChannelMethod(){
				if(location.pathname.indexOf('/data/line/channel/add') != -1){
					return {apiMethod:'INS',apiParam:{obj:'SOC' ,flt:{id:''},iData:[]}};
				} else {
					const channel_id = typeof this.$route.params.channel_id == 'undefined'?'':this.$route.params.channel_id;
					return {apiMethod:'UPD',apiParam:{obj:'SOC' ,flt:{id:channel_id},uData:[]}};
				}
			},
		SuccessGo(evt) {
			if (location.pathname.indexOf("/data/line/channel/add") != -1) {
				this.$router.push({ path: "/data/line" });
			} else {
				this.$router.push({ path: this.$GVO.str_replace("/edit", "", evt) });
			}
		},
		CancelGo(){
			this.$router.go(-1);
		}
	}
};
</script>
<style scoped>
.ReChannelEdit hr {
	color: #01b0e0;
	background-color: #01b0e0;
	height: 2px;
}
</style>